module.exports = __webpack_public_path__ + "img/shrines-1440.2dd706ba.jpg";